// Carpet supplier B2B portals (26 Oct 2026): the words and stamps of supplier stock, kept free of the API client so a
// node test can render them. The fetch hook is lib/supplier-stock.ts.
export type StockColour = {
  supplier_id: string; supplier_name: string; portal: string; read_at: string; collection: string; colour: string; code: string | null;
  variant_id: string | null; product_id: string | null; available_lm: number; rolls: number; largest_roll_lm: number | null; dye_lots: number; next_production: string | null;
};
export type StockRoll = {
  supplier_id: string; collection: string; colour: string; code: string | null; variant_id: string | null; roll_no: string | null; dye_lot: string | null;
  location: string | null; available_lm: number; price_per_lm: number | null; price_note: string | null; next_production: string | null;
};
export type CostReportRow = {
  product_id: string; product: string; collection: string; portal_price_per_lm: number | null; roll_width_m: number; portal_cost_per_m2: number | null;
  catalogue_cost_per_m2: number[]; change: 'same' | 'up' | 'down' | 'no_portal_price' | 'mixed' | 'agreed'; colours_to_move: number;
};
export type PortalRead = {
  read_id: string; supplier_id: string; portal: string; read_at: string; sydney_day: string; prices_changed: boolean; colours: number; rolls: number;
  costs_applied_at: string | null; report: CostReportRow[];
};

/** "26 Oct 07:56" — Sydney, the business's clock (AGENTS.md), whatever the device says. */
export function sydneyStamp(iso: string | null | undefined): string {
  if (!iso) return '—';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '—';
  const date = d.toLocaleDateString('en-AU', {timeZone: 'Australia/Sydney', day: 'numeric', month: 'short'});
  const time = d.toLocaleTimeString('en-AU', {timeZone: 'Australia/Sydney', hour: '2-digit', minute: '2-digit', hour12: false});
  return `${date} ${time}`;
}

/** "2026-11-06" → "6 Nov"; a production date is a plain Sydney day, never shifted. */
export function dayText(ymd: string | null | undefined): string {
  const m = String(ymd ?? '').match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!m) return '—';
  return new Date(Date.UTC(Number(m[1]), Number(m[2]) - 1, Number(m[3]))).toLocaleDateString('en-AU', {timeZone: 'UTC', day: 'numeric', month: 'short'});
}

export const metres = (n: number | null | undefined) => (n === null || n === undefined ? '—' : (Math.round(n * 10) / 10).toLocaleString('en-AU', {maximumFractionDigits: 1}));

/** The words of one colour's supplier stock: the message id and its values (the component turns them into a sentence). */
export function stockSentence(c: Pick<StockColour, 'available_lm' | 'rolls' | 'largest_roll_lm' | 'dye_lots' | 'next_production' | 'read_at'>):
  {id: 'sup.stock.line' | 'sup.stock.none' | 'sup.stock.noneNext'; values: Record<string, string | number>} {
  const at = sydneyStamp(c.read_at);
  if (c.available_lm > 0) return {id: 'sup.stock.line', values: {lm: metres(c.available_lm), rolls: c.rolls, largest: metres(c.largest_roll_lm), lots: c.dye_lots, at}};
  return c.next_production ? {id: 'sup.stock.noneNext', values: {next: dayText(c.next_production), at}} : {id: 'sup.stock.none', values: {at}};
}

